import React, { useRef } from 'react';
import type { DropIndicatorProps } from 'react-aria';
import styles from '../Collections.module.css';
import { useDragAndDropContext } from './DragAndDropProvider';

export function DropIndicator(
  props: DropIndicatorProps & {
    y?: number;
    x?: number;
    marginX?: number;
    orientation?: 'horizontal' | 'vertical';
    style?: React.CSSProperties;
  }
) {
  const { y, marginX = 0, target, style, orientation = 'vertical' } = props;

  const { dropState, dragAndDropHooks } = useDragAndDropContext();
  const ref = useRef(null);
  const { dropIndicatorProps, isHidden, isDropTarget } =
    // @ts-expect-error FIXME(strictNullChecks)
    dragAndDropHooks.useDropIndicator(
      {
        target,
      },
      // @ts-expect-error FIXME(strictNullChecks)
      dropState,
      ref
    );

  if (isHidden) {
    return null;
  }

  return (
    <div
      className={styles.dropIndicator}
      data-drop-target={isDropTarget || undefined}
      data-orientation={orientation}
      {...dropIndicatorProps}
      ref={ref}
      role="row"
      style={
        {
          '--y': `${y}px`,
          '--marginX': `${marginX}px`,
          '--x': `${props.x}px`,
          ...style,
        } as React.CSSProperties
      }
    >
      <div role="gridcell" />
    </div>
  );
}
